// src/App.js
import React from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

const App = () => {
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition
  } = useSpeechRecognition();

  const startListening = () => SpeechRecognition.startListening({ continuous: true, language: 'en-US' });

  if (!browserSupportsSpeechRecognition) {
    return (
      <div style={{ padding: 20 }}>
        <h2>Disa - Speech Recognition</h2>
        <p>Your browser does not support speech recognition. Please use Chrome, Edge, or Safari.</p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 600, margin: '40px auto', padding: 20, fontFamily: 'Arial, sans-serif' }}>
      <h2>Disa - Speech Recognition</h2>
      <p><strong>{listening ? 'Listening...' : 'Not listening'}</strong></p>
      <p style={{ background: '#f5f5f5', padding: 10, minHeight: 100, border: '1px solid #ccc' }}>
        {transcript || 'Speak into your microphone to see the transcription appear here in real-time as you speak...'}
      </p>
      <div style={{ marginTop: 10 }}>
        <button onClick={startListening}>Start Listening</button>
        <button onClick={SpeechRecognition.stopListening} style={{ marginLeft: 10 }}>Stop</button>
        <button onClick={resetTranscript} style={{ marginLeft: 10 }}>Reset</button>
      </div>

      <div style={{ marginTop: 20 }}>
        <h3>Instructions & Support</h3>
        <ul>
          <li>Speech Recognition is supported in Chrome, Edge, Safari, and newer versions of Firefox.</li>
          <li>Click "Start Listening" and grant microphone access.</li>
          <li>Speak clearly into your microphone.</li>
          <li>Click "Stop" to end recognition.</li>
          <li>Click "Reset" to clear the transcript.</li>
        </ul>
      </div>
    </div>
  );
};

export default App;
